import LogoNanciFull from "../../../assets/auth-logo-nanci-full.svg";
import LogoNanciWhite from "../../../assets/auth-logo-nanci-white.svg";
import LogoNanciBlack from "../../../assets/auth-logo-nanci-black.svg";
import LogoNanciHeaderWhite from "../../../assets/auth-logo-nanci-header-white.svg";
import LogoNanciHeaderBlack from "../../../assets/auth-logo-nanci-header-black.svg";
import LogoMBA from "../../../assets/auth-logo-mba.svg";
import LogoMGT from "../../../assets/auth-logo-mgt.svg";
import LogoEpic from "../../../assets/auth-logo-epic.svg";
import LogoEpicLarge from "../../../assets/auth-logo-epic-full.svg";
import LogoTivaRed from "../../../assets/logo-tiva-red.svg";
import LogoTiva from "../../../assets/logo-tiva-white.svg";
import TivaIcon from "../../../assets/logo-tiva.icon.svg";
import { Logo } from "../../enums/logo.enum";
import { isMobileDevice } from "../platform/platform.util";

export const getLogoImg = (logo: Logo, onlyFullImg = false, smallTivaLogo = false): string => {
    switch (logo) {
        case Logo.comet:
            return isMobileDevice() && !onlyFullImg ? LogoEpic : LogoEpicLarge;
        case Logo.nanci:
            return LogoNanciFull;
        case Logo.mba:
            return LogoMBA;
        case Logo.mgt:
            return LogoMGT;
        default:
            return !smallTivaLogo ? LogoTiva : TivaIcon;
    }
};

export const getHederLogoImg = (logo: Logo, darkTheme = false): string => {
    switch (logo) {
        case Logo.comet:
            return LogoEpic;
        case Logo.nanci:
            return !isMobileDevice()
                ? darkTheme
                    ? LogoNanciHeaderWhite
                    : LogoNanciHeaderBlack
                : darkTheme
                  ? LogoNanciWhite
                  : LogoNanciBlack;
        case Logo.mba:
            return LogoMBA;
        case Logo.mgt:
            return LogoMGT;
        default:
            return darkTheme ? LogoTiva : LogoTivaRed;
    }
};
